module.exports = __webpack_public_path__ + "fonts/icons.bb685ce.woff";